// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gurD","left":"styles_left__2EU4V"};